import React, { useEffect, useState } from 'react';
import { Calendar as BigCalendar, dateFnsLocalizer } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const CalendarData = () => {
  const [events, setEvents] = useState([]);

  // Create a date-fns localizer for react-big-calendar
  const locales = {
    'en-US': require('date-fns/locale/en-US'),
  };

  const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
  });

  useEffect(() => {
    const fetchedEvents = [
      {
        title: 'Sample Event 1',
        allDay: true,
        start: new Date(2024, 10, 14),
        end: new Date(2024, 10, 14),
      },
      {
        title: 'Sample Event 2',
        allDay: true,
        start: new Date(2024, 10, 15),
        end: new Date(2024, 10, 15),
      },
      {
        title: "Demo Birthday",
        allDay: true,
        start: new Date(2024, 10, 16),
        end: new Date(2024, 10, 16),
      },
      {
        title: "Demo Birthday-1",
        allDay: true,
        start: new Date(2024, 10, 16),
        end: new Date(2024, 10, 16),
      }
    ];

    setEvents(fetchedEvents);
  }, []);

  return (
    <div className="calendar-container h-100" >
      {/* // x---------------------------------x Big Calender Section x---------------------------------x */}
      <BigCalendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: '100%' }}
        views={['month']}
      />
    </div>
  );
};

export default CalendarData;
